import React from 'react';

import { defineMessages, useIntl } from 'react-intl';
import {
  ViewBlocks,
  PageHeader,
  InfoBox,
  RelatedItems,
  RichText,
  PageMetadata,
} from '@redturtle/iovisit-theme/components/Views';
import { CTAView } from '@redturtle/iovisit-theme/components';

const messages = defineMessages({
  timetable: { id: 'timetable', defaultMessage: 'Orari' },
  prices: { id: 'prices', defaultMessage: 'Prezzi' },
  possible_destinations: {
    id: 'Possible destinations',
    defaultMessage: 'Gli itinerari collegati a questo luogo',
  },
  to_visit_nearby: {
    id: 'To visit nearby',
    defaultMessage: 'Continua ad esplorare',
  },
});
const PointOfInterestView = ({ content, location }) => {
  const intl = useIntl();

  const timetable = RichText({
    content: content.timetable,
    title: intl.formatMessage(messages.timetable),
    titleTag: 'h3',
  });

  const prices = RichText({
    content: content.prices,
    title: intl.formatMessage(messages.prices),
    titleTag: 'h3',
  });

  const cta_data = {
    ctaLink: content.cta_url,
    ctaLinkTitle: content.cta_url_text,
    cta_title: content.cta_title,
    cta_content: content.cta_description,
    showFullWidth: true,
    bgColor: content.cta_background_color ?? 'secondary',
    ctaColor: content.cta_button_color ?? 'white',
    showImage: !!content.cta_background_image,
    ctaImage: [content.cta_background_image],
  };

  return (
    <div id="page-point-of-interest" className="ui container">
      {(timetable || prices) && (
        <InfoBox>
          {timetable} {prices}
        </InfoBox>
      )}
      <ViewBlocks content={content} location={location} />
      <RelatedItems
        title={intl.formatMessage(messages.possible_destinations)}
        items={content.possible_destinations}
        background={false}
        variation="link"
      />
      {(cta_data.ctaLink ||
        cta_data.ctaLinkTitle ||
        cta_data.cta_title ||
        cta_data.cta_content) && (
        <CTAView data={cta_data} id={content['@id']} />
      )}

      <RelatedItems
        title={intl.formatMessage(messages.to_visit_nearby)}
        items={content.to_visit_nearby}
        background={true}
        bg_color="tertiary"
      />
    </div>
  );
};

export default PointOfInterestView;
